import type { Assignment, AssignmentKind, IsoDay } from './types'

/**
 * Предварительная правка кэша назначений до ответа службы: клетка на экране меняется сразу, а её «сохраняется…» держит экран до
 * ответа. Правка не выдаётся за итог: после любого ответа (и отказа тоже) кэш перечитывается, а при отказе правка откатывается.
 * Чистая функция над черновиком списка назначений.
 */

const sameCashier = (left: string, right: string): boolean => left.toLowerCase() === right.toLowerCase()

/**
 * Ставит кассиру в один день объекта отметку `kind` (меняет вид у существующей записи) или очищает клетку (`null`). Новая запись
 * получает временный идентификатор: настоящий приходит с перечитыванием.
 */
export function applyKind(draft: Assignment[], placeId: string, cashierId: string, date: IsoDay, kind: AssignmentKind | null): void {
  const at = draft.findIndex((item) => item.placeId === placeId && item.date === date && sameCashier(item.cashierId, cashierId))
  const known = draft[at]
  if (kind === null) {
    if (known !== undefined) draft.splice(at, 1)
  } else if (known !== undefined) {
    known.kind = kind
  } else {
    draft.push({ id: `pending:${placeId}:${cashierId}:${date}`, placeId, cashierId, date, kind, updatedAt: '', updatedBy: '' })
  }
}
